import { Progress, ProgressProps } from 'antd';

interface IProgress extends ProgressProps {
  percent: number;
}

export const AProgress: React.FC<IProgress> = ({ percent, ...res }) => {
  return (
    <Progress
      percent={percent}
      status={percent === 100 ? 'success' : 'active'}
      {...res}
    />
  );
};
